// extracted by mini-css-extract-plugin
export var li = "_vi-2";
export var ol = "_vi-1";
export var ul = "_vi-0";